import { Checkbox } from '../../../../common/Form'
import { NimbraVAApplianceSettings } from 'common/api/v1/types'

interface Props {
  settings: NimbraVAApplianceSettings
}

const NimbraVaSettingsComp = (_: Props) => {
  return (
    <Checkbox
      label="Automatically managed tunnel routes"
      name={`settings.autoRouteTunnels`}
      tooltip="Enabling this option allows the VA to automatically manage route entries for dual ISP redundancy. Two default routes, one per network interface, must be manually added. Edge will ensure tunnel traffic is correctly routed through each ISP"
    />
  )
}

export default NimbraVaSettingsComp
